import generateRender from 'shared/utils/generateRender';
import DefaultPurchaseHeader from '../../../../components/JSModal/components/DefaultHeader';

const VipAccessHeader = generateRender({
  default: DefaultPurchaseHeader,
});

export default VipAccessHeader;

